import { RuleCondition } from "../medicalRules/medicalRules";

export enum NSA_IDENTIFICATION_RULE_SELECTIONS {
  remark_code = "Remark Code",
  attachment_control_number = "Attachment Control Number",
}
export enum TIMELY_FILING_RULE_SELECTIONS {
  billing_provider_tin = "Billing Provider TIN",
  other_payer_name = "Other Payer Name",
}
export enum PROMPT_PAY_RULE_SELECTIONS {
  network = "Network",
  provider_tin = "Provider TIN",
}
export enum PRIOR_AUTHORIZATION_RULE_SELECTIONS {
  place_of_service = "Place of Service Code",
  procedure_code = "Procedure Code",
  billed_amount = "Billed Amount",
  revenue_code = "Revenue Code",
  claim_type = "Claim Type",
  bill_type_code = "Bill Type Code",
}
export enum SUBMITTER_IDENTIFICATION_RULE_SELECTIONS {
  submitter_last_name_or_organization_name = "Submitter Last Name or Organization Name",
}
export enum OUT_OF_NETWORK_IDENTIFICATION_RULE_SELECTIONS {
  repricing_organization_identifier = "Repricing Organization Identifier",
}

export const RULE_SELECTION = {
  ...NSA_IDENTIFICATION_RULE_SELECTIONS,
  ...TIMELY_FILING_RULE_SELECTIONS,
  ...PROMPT_PAY_RULE_SELECTIONS,
  ...PRIOR_AUTHORIZATION_RULE_SELECTIONS,
  ...SUBMITTER_IDENTIFICATION_RULE_SELECTIONS,
  ...OUT_OF_NETWORK_IDENTIFICATION_RULE_SELECTIONS,
};

export type NetworkRuleSelectionTypes =
  | keyof typeof NSA_IDENTIFICATION_RULE_SELECTIONS
  | keyof typeof TIMELY_FILING_RULE_SELECTIONS
  | keyof typeof PROMPT_PAY_RULE_SELECTIONS
  | keyof typeof PRIOR_AUTHORIZATION_RULE_SELECTIONS
  | keyof typeof SUBMITTER_IDENTIFICATION_RULE_SELECTIONS
  | keyof typeof OUT_OF_NETWORK_IDENTIFICATION_RULE_SELECTIONS;

export interface MedicalNetwork {
  readonly id: number;

  readonly external_medical_network_id?: string;
  readonly created_at?: string;
  readonly created_by?: string;
  readonly end_date?: string;
  readonly is_rented?: boolean;
  readonly is_third_party_vendor?: boolean;
  readonly is_response_file_required?: boolean;
  readonly is_out_of_network?: boolean;
  readonly medical_network_version_id?: string;
  readonly prior_authorization_requirements?: NetworkRules;
  readonly prompt_pay?: NetworkRules;
  readonly name?: string;
  readonly nsa_identification?: NetworkRules;
  readonly out_of_network_identification?: NetworkRules;
  readonly should_automatically_reprocess_adjustments?: boolean;
  readonly should_trust_submitted_other_payer_info?: boolean;
  readonly start_date?: string;
  readonly submitter_identification?: NetworkRules;
  readonly timely_filing?: NetworkRules;
  readonly default_timely_filing?: string;
  readonly is_provider_w9_required?: boolean;
}

export interface NetworkRules {
  readonly rules: ReadonlyArray<MedicalNetworkRule>;
  readonly out_of_network_id?: number;
  readonly default_timely_filing?: string;
}

export type MedicalNetworkRule = {
  readonly name: string;
  readonly definitions: ReadonlyArray<ReadonlyArray<RuleCondition<NetworkRuleSelectionTypes>>>;
  readonly description: string;
  // timely_filling
  readonly time_limit?: string;
  // prompt_pay
  readonly timeframe_unit?: string;
  readonly number_of_days?: string;
};
